module.exports = __webpack_public_path__ + "static/media/R-280HD_CrossSection.f4f02721.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-280HD_CrossSection.png
// module id = 485
// module chunks = 0